export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11266.ae5701f9.jpg";